import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=350ed5cc&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350ed5cc')) {
      api.createRecord('350ed5cc', component.options)
    } else {
      api.reload('350ed5cc', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=350ed5cc&", function () {
      api.rerender('350ed5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fXoMIgTlwGWg/JS/comp/ErrorMessage.vue"
export default component.exports